import { PRIORIDADE_MAP } from '../../lib/constants';
import { Badge } from '../ui/Badge';
import { AlertTriangle, Flame } from 'lucide-react';

export function PrioridadeBadge({ prioridade, inline = false }) {
  const p = PRIORIDADE_MAP[prioridade] || PRIORIDADE_MAP.media;
  if (inline) {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11, color: p.dotColor }}>
        <span style={{ width: 6, height: 6, borderRadius: 3, background: p.dotColor }} />
        {p.label}
      </span>
    );
  }
  const Icon = prioridade === 'urgente' ? Flame : prioridade === 'alta' ? AlertTriangle : null;
  return (
    <Badge color={p.color}>
      {Icon && <Icon size={11} style={{ marginRight: 2 }} />}
      {p.label}
    </Badge>
  );
}
